import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { PaymentRetryFlowManagerService } from '../services/payment-retry-flow-manager.service';
@Component({
  selector: 'app-payment-retry-flow',
  templateUrl: './payment-retry-flow.component.html',
  styleUrls: ['./payment-retry-flow.component.scss']
})
export class PaymentRetryFlowComponent implements OnInit {
  policy!: { [key: string]: any };
  formData!: any;
  isLoading!: boolean;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public retryPaymentFlowManagerService: PaymentRetryFlowManagerService
  ) { }

  ngOnInit(): void {
    this.isLoading = true;

    if (this.route.snapshot.data.policy) {
      this.policy = this.route.snapshot.data.policy;

      this.retryPaymentFlowManagerService.getFirstStep(this.policy)
        .then((response: any) => {
          this.formData = response;
          this.isLoading = false;
        })
        .catch(() => {
          this.router.navigate(['/bad-request']);
        });
    };
  }

}
